import { AddCircleOutlineOutlined as AddCircleOutlineOutlinedIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { IHeaderGroupParams } from "ag-grid-community";

interface CustomHeaderGroupProps extends IHeaderGroupParams {
	onAddSample?: () => void;
	gradeId?: number | null;
	hasElements?: boolean;
}

export const CustomHeaderGroup = (props: CustomHeaderGroupProps) => {
	const { displayName, onAddSample, gradeId, hasElements = true } = props;

	return (
		<div
			style={{
				display: "grid",
				gridTemplateColumns: "1fr auto 1fr",
				alignItems: "center",
				width: "100%",
				position: "relative",
			}}
		>
			{/* Add Sample Button - Left */}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: "8px",
					justifySelf: "start",
				}}
			>
				{onAddSample && (
					<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
						<IconButton
							color="primary"
							onClick={() => {
								onAddSample();
							}}
							title="Add Sample"
							style={{ padding: "6px" }}
						>
							<AddCircleOutlineOutlinedIcon
								style={{ cursor: "pointer", fontSize: "22px" }}
							/>
						</IconButton>
						<span
							style={{
								fontSize: "0.7rem",
								fontWeight: "normal",
							}}
						>
							Add Sample
						</span>
					</div>
				)}
			</div>

			{/* Title - Center */}
			{hasElements && (
				<span
					style={{
						color: "black",
						fontSize: "0.8rem",
						justifySelf: "center",
					}}
				>
					{displayName}
				</span>
			)}
			{!hasElements && <span style={{ justifySelf: "center" }}></span>}

			{/* Right side - empty for now */}
			<div style={{ justifySelf: "end" }}></div>
		</div>
	);
};
